/**
 * `Imported Oct 13 · roster.xlsx`: how an import batch is named in the summary and on the
 * Members list banner.
 *
 * @param {(key: string, values: object) => string} t
 * @param {string} locale
 * @param {Date} date
 * @param {string} fileName
 */
export function formatBatchLabel(t, locale, date, fileName) {
  const day = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(date);
  return t('import.check.batch.label', { date: day, file: fileName });
}
